export default "__VITE_ASSET__CGfpCjGL__"